import React from 'react';
import enUS from '../tokens/en-US.json';
import esES from '../tokens/es-ES.json';
import jpJP from '../tokens/jp-JP.json';
import ptBR from '../tokens/pt-BR.json';
import arrowIcon from '../assets/icons/arrow_teal.svg';

export const translations = {
  'en-US': enUS,
  'es-ES': esES,
  'jp-JP': jpJP,
  'pt-BR': ptBR,
};

export const Text = ({ languageCode, token }) => <span dangerouslySetInnerHTML={{__html: translations[languageCode][token]}}></span>;

export const Button = ({ languageCode, onClick, token, icon, gray_icon, url, id, className }) =>
    <a id={id} className={className} onClick={onClick} href={translations[languageCode][url] ? translations[languageCode][url] : ''} >
        <img src={icon} alt=""/>
        <span id={id} className={className} dangerouslySetInnerHTML={{__html: translations[languageCode][token]}}></span>
        <img src={arrowIcon} alt=""/>
    </a>;
